$(function(){
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hover-video').forEach((wrapper) => {
    const video = wrapper.querySelector('video');

    if (!video) return;

    wrapper.addEventListener('mouseenter', () => {
      video.play().catch(() => {});
    });

    wrapper.addEventListener('mouseleave', () => {
      video.pause();
    });
  });
});